import { IncidentModel } from './incident.model';

export class IncidentFinanceCollectionModel extends IncidentModel {
    public incidentFinanceCollectionId = 0;
    public customerOutstandingBalanceId = 0;
    public amountDue: string;
    public interestDue?: string;
    public penaltyDue?: string;
}
